import {Program} from '../../beam/index'
import settings from '../settings';

import ToneMappingVS from '../shaders/tone-mapping-vs.glsl';
import ToneMappingFS from '../shaders/tone-mapping-fs.glsl';

export default class ToneMappingRenderPass {

    constructor(renderer) {
        this.renderer = renderer
        this.material = new Program(this.renderer.gl, {
			vertexShader:   ToneMappingVS,
			fragmentShader: ToneMappingFS
        });
        this.material.name = 'Tone MApping'
    }

    resize(w, h) {

    }

    render(bufferScene, bufferPlane, bufferCamera, input, output) {
        bufferPlane.material = this.material;
        if (this.material.uniforms.tInput)
            this.material.uniforms.tInput.value = input;
        this.renderer.clearColor(0,0,0,1)
        this.renderer.clear()
        bufferPlane.id = 'ToneMappingPass'
        bufferPlane.name = 'ToneMappingPass'
        // this.material.setUniform('useACESFilmToneMapping', settings.useACESFilmToneMapping ? 1 : 0);
        this.material.setUniform('useACESFitted', settings.useACESFitted ? 1 : 0);
        this.material.setUniform('uACESExpCompensation', settings.uACESExpCompensation);
        this.renderer.render( bufferScene, bufferCamera, output );
    }

}